import { useEffect } from "react";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { TrackingObject } from "@features/analytics/utils/types";
import { useMyBtKeywords } from "@features/mybt/hooks/useMyBtKeywords";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIsFirstMount } from "@hooks/useIsFirstMount";
import { useGetMyBTArticleList } from "@routes/MyAccount/hooks/useGetMyBTArticleList";

import MyAccountPopoverMyBTEmptyState from "./MyAccounMyBTPopoverEmptyState";
import MyAccounMyBTPopoverList from "./MyAccounMyBTPopoverList";

export default function MyAccounMyBTPopover(): React.ReactElement {
  const { loginId } = useUserInfo();
  const sendDataToGTM = useSendDataToGTM();
  const isFirstMount = useIsFirstMount();

  const { tags } = useMyBtKeywords();

  const { myBTArticleList, isLoading } = useGetMyBTArticleList({
    tags,
    size: 2,
    tagSize: 2,
    isPopover: true,
  });

  const isEmptyState = myBTArticleList.length === 0;

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isFirstMount) return;

    const userKeywords = tags?.map(({ name }) => name).join("|");

    const gaObject: TrackingObject = {
      event: "custom_event",
      eventCategory: "mybt",
      eventAction: "visible",
      eventLabel: window.location.href,
    };

    if (userKeywords) {
      gaObject["user_keyword"] = userKeywords;
    }

    sendDataToGTM(gaObject);
  }, [tags, sendDataToGTM, isFirstMount]);

  return (
    <div
      data-testid="my-account-more-info-read-component"
      className="w-[360px] p-6"
    >
      {!loginId || (isEmptyState && !isLoading) ? (
        <MyAccountPopoverMyBTEmptyState />
      ) : null}

      {!isEmptyState && loginId && !isLoading ? (
        <MyAccounMyBTPopoverList tagWithArticleList={myBTArticleList} />
      ) : null}

      {isLoading && loginId ? (
        <div className="text-center">
          <FontAwesomeIcon icon={faSpinner} size="2x" spin className="mb-6" />
        </div>
      ) : null}
    </div>
  );
}
